var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @public */
export var baseBorderRadii = {
    none: 'none',
    xsm: '2px',
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    '2xl': '24px',
    '3xl': '32px',
    full: '9999px',
};
/** @public */
export var actionBorderRadii = {
    'action-sm': '9999px',
    'action-md': '9999px',
    'action-lg': '12px',
};
/** @public */
export var borderRadii = __assign(__assign({}, baseBorderRadii), actionBorderRadii);
/** @public */
export var shadows = {
    sm: '0 -1px 0 0 rgba(0, 0, 0, 0.03), 0 0 1px 0 rgba(0,0,0,0.24),0 2px 1px -1px rgba(0,0,0,0.16),0 2px 4px 0 rgba(0,0,0,0.12)',
    md: '0 -1px 0 0 rgba(0, 0, 0, 0.03), 0 0 2px 0 rgba(0,0,0,0.2),0 4px 2px -2px rgba(0,0,0,0.12),0 4px 8px -1px rgba(0,0,0,0.16)',
    lg: '0 -1px 0 0 rgba(0, 0, 0, 0.03), 0 1px 4px 0 rgba(0,0,0,0.2),0 6px 4px -4px rgba(0,0,0,0.12),0 8px 16px -1px rgba(0,0,0,0.16)',
    xl: '0 -1px 0 0 rgba(0, 0, 0, 0.03), 0 2px 8px 0 rgba(0,0,0,0.16),0 10px 8px -5px rgba(0,0,0,0.16),0 12px 32px -2px rgba(0,0,0,0.16)',
    '2xl': '0 -1px 0 0 rgba(0, 0, 0, 0.03), 0 4px 12px 0 rgba(0,0,0,0.16),0 12px 12px -4px rgba(0,0,0,0.16),0 24px 64px -2px rgba(0,0,0,0.16)',
    'overlay-md': '0 -1px 0 0 rgba(0, 0, 0, 0.03), 0 4px 16px 0 rgba(0, 0, 0, 0.2), 0 4px 16px -4px rgba(0, 0, 0, 0.2), 0 12px 24px -2px rgba(0, 0, 0, 0.2)',
    'overlay-lg': '0 -1px 0 0 rgba(0, 0, 0, 0.03), 0 8px 32px 0 rgba(0,0,0,0.24),0 8px 16px 0 rgba(0,0,0,0.2),0 24px 64px 0 rgba(0,0,0,0.2)',
    'overlay-xl': '0 -1px 0 0 rgba(0, 0, 0, 0.03), 0 24px 72px 0 rgba(0,0,0,0.48),0 8px 16px 0 rgba(0,0,0,0.12),0 24px 64px 0 rgba(0,0,0,0.2)',
};
/** @public */
export var brandRefreshTheme = { borderRadii: borderRadii, shadows: shadows };
//# sourceMappingURL=theme.js.map